var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-3 py-4"},[_c('section',{staticClass:"d-flex flex-column flex-sm-row justify-content-between"},[_c('h2',{staticClass:"my-2"},[_vm._v(" Dashboard ")]),_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumb}})],1),_c('list-requests'),_c('br'),_c('chart-requests')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }